import { render } from "./AyudaInterconsulta.vue?vue&type=template&id=17850e4c&scoped=true"
import script from "./AyudaInterconsulta.vue?vue&type=script&lang=js"
export * from "./AyudaInterconsulta.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=17850e4c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17850e4c"]])

export default __exports__